import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import SiteAdmin from '../components/SiteAdmin';
import Page from '../../../components/Page';
import { ReportStore } from '../../../store';
import Container from '@material-ui/core/Container';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import ReportIcon from '@material-ui/icons/InsertChart';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import { ReportAPI } from '../../../api';
import withAdminOnly from '../components/AdminOnly';

const useStyles = makeStyles({
  title: {
    marginBottom: '2rem',
  },
});


const ReportLink = ({name, title, description}) => {
  const [busy, setBusy] = useState(false);
  const getDownloadUrl = async name => {
    try {
      setBusy(true);
      const { payload } = await ReportAPI.getReportUrl(name);
      window.open(payload.url);
    } finally {
      setBusy(false);
    }
  };

  return (
    <List aria-label="report list">
      <ListItem button component={Link} to={`/siteadmin/reports/${name}`}>
        <ListItemAvatar>
          <Avatar>
            <ReportIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={title}
          secondary={description}
        />
        <ListItemSecondaryAction>
          <IconButton disabled={busy} edge="end" aria-label="delete" onClick={()=>getDownloadUrl(name)}>
            <DownloadIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    </List>
  );
};

ReportLink.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const AdminReportListPage = ({ reportList, dispatch }) => {
  const classes = useStyles();

  useEffect(() => {
    dispatch(ReportStore.refreshReportList());
  }, []);  // eslint-disable-line

  return (
    <Page title="Admin Reports">
      <SiteAdmin>
        <Typography variant="h6" color="primary" className={classes.title}>Clickablity Reports</Typography>
        <Container>
          {reportList.map(report => <ReportLink key={report.name} name={report.name} title={report.title} description={report.description}/>)}
        </Container>
      </SiteAdmin>
    </Page>
  );
};

AdminReportListPage.propTypes = {
  reportList: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    reportList: state.report.reportList,
  };
};

export default connect(mapStateToProps)(withAdminOnly(AdminReportListPage));
